<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- <el-tab-pane label="分销设置" name="first">
          <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
              <el-form-item label="分销启用：" prop="enableCommission">
                <el-radio-group v-model="ruleForm.enableCommission">
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="一级返佣比例：" prop="firstLevelCommissionRate">
                <el-input style="width: 420px;" v-model="ruleForm.firstLevelCommissionRate" placeholder="请输入一级返佣比例（%）"></el-input>
              </el-form-item>
              <el-form-item label="二级返佣比例：" prop="twoLevelCommissionRate">
                <el-input style="width: 420px;" v-model="ruleForm.twoLevelCommissionRate" placeholder="请输入二级返佣比例（%）"></el-input>
              </el-form-item>
              <el-form-item label="分销海报：" prop="commissionPoster">
                <el-upload
                  :action="baseUrl+'/system/common/upload/uploadFile'"
                  list-type="picture-card"
                  :headers="{'Authorization': token}"
                  :multiple="false"
                  :limit="1"
                  :file-list="fileList"
                  :on-remove="delImgBtn"
                  :on-success="uploadImgBtn">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">建议尺寸：670*1028px，若需要更换图片，请先删除原图片</div>
                </el-upload>
              </el-form-item>
              <el-form-item label="佣金提现说明：" prop="commissionTakeDesc">
                <editor :value="ruleForm.commissionTakeDesc" :height="350" v-model="ruleForm.commissionTakeDesc"></editor>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane> -->
        <el-tab-pane label="佣金设置" name="second">
          <div><el-button @click="editBtn('')" size="small" type="primary" class="bg-theme">添加推广者等级</el-button></div>
          <div style="margin-top: 16px;">
            <el-table
              border
              :data="infoList">
              <el-table-column
                align="center"
                prop="id"
                label="ID">
              </el-table-column>
              <el-table-column
                align="center"
                prop="promoterName"
                label="推广者名称">
              </el-table-column>
              <el-table-column
                align="center"
                prop="isDefault"
                label="是否默认">
                <template slot-scope="scope">
                  <span v-if="scope.row.isDefault === 1">是</span>
                  <span v-else>否</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="totalRate"
                label="总佣金比例">
              </el-table-column>
              <el-table-column
                align="center"
                prop="cashRate"
                label="现金构成比例">
              </el-table-column>
              <el-table-column
                align="center"
                prop="moneyRate"
                label="余额构成比例">
              </el-table-column>
              <el-table-column
                align="center"
                prop="createTime"
                label="创建时间">
              </el-table-column>
              <el-table-column
                align="center"
                prop="updateTime"
                label="更新时间">
              </el-table-column>
              <el-table-column
                align="center"
                width="240"
                label="操作">
                <template slot-scope="scope">
                  <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
                  <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-page-bottom flex-end-row">
              <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-dialog
      title="添加推广者等级"
      :visible.sync="editShow"
      width="960px">
      <el-form :model="editForm" :inline="true" label-width="140px">
        <el-form-item label="推广者名称：" prop="promoterName">
          <el-input style="width: 424px;" v-model="editForm.promoterName" placeholder="请输入推广者名称"></el-input>
        </el-form-item>
        <el-form-item label="现金构成比例：" prop="cashRate">
          <el-input style="width: 424px;" v-model="editForm.cashRate" placeholder="请输入现金构成比例"></el-input>
        </el-form-item>
        <el-form-item label="余额构成比例：" prop="moneyRate">
          <el-input style="width: 424px;" v-model="editForm.moneyRate" placeholder="请输入余额构成比例"></el-input>
        </el-form-item>
        <el-form-item label="是否默认：" prop="isDefault">
          <div style="width: 424px;">
            <el-switch v-model="editForm.isDefault">
            </el-switch>
          </div>
        </el-form-item>
        <el-form-item label="  ">
          <div style="width: 424px;">
            <el-button type="primary" @click="saveEditBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { saveOrUpdateCommissionConfig, fetchCommissionConfigDetail, queryCommissionPromoterLevelPageList, removeCommissionPromoterLevelById, saveCommissionPromoterLevel, updateCommissionPromoterLevel, fetchCommissionPromoterLevelDetailById } from '@/api/commission'
import Editor from '@/components/Editor.vue'
export default {
  name: 'Service_agreement',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      limitLength: this.$limitLength,
      fullscreenLoading: false,
      activeName:'second',
      fileList:[],
      ruleForm: {
        firstLevelCommissionRate:'',
        twoLevelCommissionRate:'',
        enableCommission:1,
        commissionPoster:'',
        commissionTakeDesc: ''
      },
      rules: {
        enableCommission: [
          { required: true, message: '请选择分销启用', trigger: 'blur' }
        ],
        firstLevelCommissionRate: [
          { required: true, message: '请输入一级返佣比例（%）', trigger: 'blur' }
        ],
        twoLevelCommissionRate: [
          { required: true, message: '请输入二级返佣比例（%）', trigger: 'blur' }
        ]
      },
      infoList:[],
      infoId:'',
      pageTotal: 0,
      currentPage: 1,
      // 添加推广者等级弹窗
      editShow:false,
      editForm: {
        promoterName: '',
        cashRate: '',
        moneyRate: '',
        isDefault: false
      }
    }
  },
  mounted () {
    var that = this;
    that.detailInfoFun();
  },
  methods: {
    handleClick(tab){
      if(tab.name === 'second'){
        this.getInfoList()
      }
    },
    detailInfoFun(){
      let that = this
      fetchCommissionConfigDetail({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.fileList = [{url: data.commissionPoster}]
          that.ruleForm = data
        }
      })
    },
    uploadImgBtn(file){
      this.ruleForm.commissionPoster = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var commissionPoster = '';
      fileList.forEach(function(item){
        commissionPoster = item.url;
      });
      this.ruleForm.commissionPoster = commissionPoster;
    },
    // 保存操作
    saveBtn () {
      let that = this
      let ruleForm = that.ruleForm
      if (ruleForm.firstLevelCommissionRate === '') {
        this.$message.error('请输入一级返佣比例（%）')
        return false
      }
      if (ruleForm.twoLevelCommissionRate === '') {
        this.$message.error('请输入二级返佣比例（%）')
        return false
      }
      that.fullscreenLoading = true
      saveOrUpdateCommissionConfig(ruleForm).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          let data = res.data
          that.$message.success(res.msg)
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg)
        }
      })
    },
    // 获取数据
    getInfoList () {
      let that = this
      let page = that.currentPage
      queryCommissionPromoterLevelPageList({ pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 编辑 */
    editBtn (infoId) {
      this.editForm = {
        promoterName: '',
        cashRate: '',
        moneyRate: '',
        isDefault: false
      }
      this.infoId = infoId;
      var that = this;
      if(infoId == ''){
        that.editShow = true;
      }else{
        fetchCommissionPromoterLevelDetailById({id:infoId}).then((res) => {
          if (res.errorCode === '0000') {
            var data = res.data;
            that.editForm = {
              promoterName: data.promoterName,
              cashRate: data.cashRate,
              moneyRate: data.moneyRate,
              isDefault: data.isDefault == 1 ? true : false
            }
            that.editShow = true;
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 添加推广者等级弹窗-保存操作
    saveEditBtn(){
      var that = this;
      var infoId = that.infoId;
      var editForm = that.editForm;
      var passData = {
        promoterName: editForm.promoterName,
        cashRate: editForm.cashRate,
        moneyRate: editForm.moneyRate,
        isDefault: editForm.isDefault ? 1 : 0
      }
      if(infoId == ''){
        saveCommissionPromoterLevel(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        passData.id = infoId;
        updateCommissionPromoterLevel(passData).then((res) => {
          that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.editForm = {
              promoterName: '',
              cashRate: '',
              moneyRate: '',
              isDefault: false
            }
            that.editShow = false;
            that.$router.go(0)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeCommissionPromoterLevelById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/commission/Commission.vue